<main id="onboard" class="onboard auto-height">
  <section id="wifi-onboard-connect" class="wifi-onboard-bookref wifi-onboard-connect modal"
    data-modal="wifi-onboard-connect" style="display: block !important">
    <app-error *ngIf="showErrorMsg"></app-error>
    <div class="form-wrapper mob-view">

      <div class="wrapper wrapperIpad">
        <div class="modal-body">
          <header>
            <button id="activate-close" type="button" class="modal-close" data-modal-close="wifi-onboard-connect"
              (click)="closeVoucherConnectOverlay()" tabindex="0" [attr.aria-label]="('close' | translate)">×</button>
            <div class="wifi-icon">

            </div>
            <h3 class="activate-header">Crew Login</h3>
          </header>

          <div class="activate-content">
            <div class="wifi-eligibility-text mrgn-t-2">
              <p class="wifi-notification-eurobonus">Please fill the details below</p>
            </div>
            <div class="req-info login">
              <span>* Required information</span>
            </div>
            <div class="activate-form">
              <form [formGroup]="crewForm" class="pnr-input-form" role="form" name="wifi-onboard-connect-bookRef"
                autocomplete="off" novalidate="" form-autofill-fix="">

                <div class="input-set large-6 medium-6 small-12 col activate-input firstname-input">
                  <label id="firstNameLabel" [ngClass]="{'top-set': fnameTopSet}"
                    for="firstName">{{'wifiLogin.textBox.firstName' | translate}}*</label>
                  <input formControlName='firstName' id="firstName" name="" type="text" value="" class="no-radius-hover"
                    aria-invalid="false" tabindex="0" role="textbox" (focus)="onActiveFname()" (blur)="onBlurFname()"
                    required>
                  <div class="tool-tip bottom-left small error onboard-tool-tip"
                    *ngIf="firstName.invalid && showFnameErrorMsg" role="alert">
                    <div class="tool-tip-inner">
                      <div *ngIf="firstName.errors.required">Please enter your first name.</div>
                      <div *ngIf="firstName.errors.pattern || firstName.errors.minlength">Please verify your Fname</div>
                      <div *ngIf="firstName.errors.maxlength && !firstName.errors.pattern">
                        Your first name can't be longer than 32 letters.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-set large-6 medium-6 small-12 col activate-input lastname-input">
                  <label id="lastNameLabel" [ngClass]="{'top-set': lnameTopSet}" for="lastName">Last name*</label>

                  <input formControlName='lastName' id="lastName" name="" type="text" value="" class="no-radius-hover"
                    [attr.aria-label]="('wifiLogin.textBox.lastName' | translate)" aria-invalid="false" tabindex="0"
                    role="textbox" (focus)="onActiveLname()" (blur)="onBlurLname()" required>

                  <div class="tool-tip bottom-left small error onboard-tool-tip"
                    *ngIf="lastName.invalid && showLnameErrorMsg" role="alert">
                    <div class="tool-tip-inner">
                      <div *ngIf="lastName.errors.required">Please enter your last name.</div>
                      <div *ngIf="lastName.errors.pattern || lastName.errors.minlength">Please verify your Lname.
                      </div>
                      <div *ngIf="lastName.errors.maxlength && !lastName.errors.pattern">
                        Your last name can't be longer than 32 letters.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-set large-6 medium-6 small-12 col activate-input email-input">
                  <label id="emailLabel" [ngClass]="{'top-set': emailTopSet}" for="email">Email*</label>
                  <input formControlName='email' id="email" name="" type="text" value="" class="no-radius-hover"
                    [attr.aria-label]="('email' | translate)" aria-invalid="false" tabindex="0" role="textbox"
                    (focus)="onActiveEmail()" (blur)="onBlurEmail()" required>
                  <button type="button" id="infofree" class="infofree" tabindex="0" (focus)="onActiveEmailInfoIcon()"
                    (blur)="onBlurEmailInfoIcon()" (click)="onActiveEmailInfoIcon()"
                    (clickOutside)="onBlurEmailInfoIcon()" [attr.aria-label]="('pnr.toolTip' | translate)"
                    name="loginoption">

                    <svg class="info-circle-icon" role="presentation">
                      <use xlink:href="#cl--info-circle" href="#cl--info-circle"></use>
                    </svg>
                  </button>
                  <div class="tool-tip bottom-right small" *ngIf="displayEmailInfo">
                    <div class="tool-tip-inner info-tool-tip">Please enter the SAS business email.</div>
                  </div>
                  <div class="tool-tip bottom-left small error onboard-tool-tip"
                    *ngIf="email.invalid && showEmailErrorMsg" role="alert">
                    <div class="tool-tip-inner">
                      <div *ngIf="email.errors.required">Please enter your email.</div>
                      <div *ngIf="email.errors.pattern">Please enter a valid email address.</div>
                    </div>
                  </div>
                </div>

                <div class="input-set large-6 medium-6 small-12 col mar activate-input">
                  <label [ngClass]="{'top-set': pnrTopSet}" for="voucher">Voucher Code*</label>
                  <input formControlName='voucherCode' id="voucher" name="" type="text" value=""
                    (focus)="onActiveCrewVoucher()" aria-invalid="false" tabindex="0" role="textbox"
                    (blur)="onBlurVoucher()" required />

                  <button type="button" id="infofree" class="infofree" tabindex="0" (focus)="onActiveVoucherInfoIcon()"
                    (blur)="onBlurVoucherInfoIcon()" (click)="onActiveVoucherInfoIcon()"
                    (clickOutside)="onBlurVoucherInfoIcon()" [attr.aria-label]="" name="loginoption">

                    <svg class="info-circle-icon" role="presentation">
                      <use xlink:href="#cl--info-circle" href="#cl--info-circle"></use>
                    </svg>
                  </button>
                  <div class="tool-tip bottom-right small" *ngIf="displayVoucherInfo">
                    <div class="tool-tip-inner info-tool-tip">Your voucher code has 8 characters.</div>
                  </div>

                  <div class="tool-tip bottom-left small error onboard-tool-tip"
                    *ngIf="voucherCode.invalid && showVoucherErrorMsg" role="alert">
                    <div class="tool-tip-inner">
                      <div *ngIf="voucherCode.errors.required">Please enter the Voucher Code</div>
                      <div *ngIf="voucherCode.errors.pattern || voucherCode.errors.minlength">Voucher code should be 8
                        characters.
                      </div>
                      <div *ngIf="voucherCode.errors.maxlength && !voucherCode.errors.pattern">
                        Voucher code should be 8 characters.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="clear"></div>
                <div id="onboard-connect-btn" class="activate-connect-button">
                  <button type="submit" tabindex="0" class="btn onboard-connect-button primary"
                    (click)="voucherFormSubmit()" role="button">
                    Continue
                  </button>
                </div>
              </form>
            </div>

          </div>
          <div class="clear"></div>


          <div class="wifi-notification mrgn-t-30 text-info">
            <p class="text-white wifi-disclaimer text-padding">The information you enter above will be used to verify
              your voucher code.</p>

            <p class="text-white wifi-disclaimer">There may be temporary service interruptions on some flights over the
              North Sea, the Bay of Biscay, Russian airspace, Svalbard and the Canary Islands.</p>
          </div>
          <!-- modal content end -->
        </div>
        <!-- modal body end -->
      </div>
    </div>
  </section>
</main>
<!-- modal end -->